import React from "react";
import Modal from "@mui/material/Modal";

const CancelModal = ({ open, handleClose, children }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="edit-modal-payment">{children}</div>
    </Modal>
  );
};

export default CancelModal;
